import { CustomAxiosError } from '@calm/evexia-web-sdk';
import { AxiosError } from 'axios';

export function identifyApiErrorCode(
    error: CustomAxiosError | AxiosError
): string | null {
    if (
        !!error?.response?.data &&
        typeof error.response.data === 'object' &&
        'errorCode' in error.response.data
    ) {
        return error.response.data.errorCode as string;
    } else {
        return null;
    }
}
